<template>
  <div>
    <CommonTab>
      <div slot="main-menu" @click="$router.push('/')">商城首页</div>
      <ChannelTabMenu slot="other-menu">
        <CommonTabMenuItem to="/">癫痫栏目</CommonTabMenuItem>
      </ChannelTabMenu>
    </CommonTab>
    <div class="img">
      <img src="@/assets/pc/images/channel/4.png" alt="" />
    </div>
  </div>
</template>

<script>
import CommonTab from "@/components/pc/nav/CommonTab";
import ChannelTabMenu from "@components/pc/nav/ChannelTabMenu";
import CommonTabMenuItem from "@components/pc/nav/CommonTabMenuItem";
export default {
  name: "Epilepsy",
  components: {
    CommonTab,
    ChannelTabMenu,
    CommonTabMenuItem
  }
};
</script>

<style lang="stylus" scoped>
.img
  img
    width 100%
    height 100%
</style>
